import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PlaybackStartingTitle from './PlaybackStartingTitle';
import PlaybackStartingSubtitle from './PlaybackStartingSubtitle';
import { PlaybackContext } from '../../contexts/PlaybackContext';

export default function PlaybackStartingPreparing() {
	const { t } = useTranslation();
	const { playlistItem } = useContext(PlaybackContext);

	const subtitle = useMemo(() => {
		if (!playlistItem) return null;

		return playlistItem.getContentTitle();
	}, [playlistItem]);

	return (
		<div>
			<PlaybackStartingTitle>{t('PlaybackStarting.Preparing.Title')}</PlaybackStartingTitle>
			<PlaybackStartingSubtitle>{subtitle}</PlaybackStartingSubtitle>
		</div>
	);
}
